interface FieldErrorProps {
  id: string;
  errors: string[];
}

export default function FieldError({ id, errors }: FieldErrorProps) {
  if (errors.length === 0) return null;
  
  return (
    <>
      {errors.map((err, i) => (
        <p
          key={i}
          id={`${id}-error-${i}`}
          className="text-(--text-error) text-sm font-medium"
          role="alert"
        >
          {err}
        </p>
      ))}
    </>
  );
}
